module.exports = __webpack_public_path__ + "static/img/gmail.69743d1c.svg";